/* Gentle Beauty — cross-sell & upsell: product recommendations (lazy), recently viewed, frequently bought together,
   complementary products block. Uses window.GB from gb-theme.js. No dependencies. */
(function () {
  'use strict';
  if (window.GBRecs) return;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (c) { return window.GB && GB.formatMoney ? GB.formatMoney(c) : '$' + (c / 100).toFixed(2); };
  var design = window.Shopify && window.Shopify.designMode;
  var rootUrl = function () {
    var r = (window.GBConfig && GBConfig.routes && GBConfig.routes.root) || '/';
    return r.replace(/\/$/, '');
  };
  var fetchDoc = function (url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  };
  var whenVisible = function (el, cb, margin) {
    if (!('IntersectionObserver' in window)) return cb();
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); cb(); }
    }, { rootMargin: margin || '400px 0px' });
    io.observe(el);
  };
  var initInjected = function (el) { if (window.GB && GB.init) GB.init(el); };

  /* ---------- Mini card variant select (shared) ---------- */
  if (!window.__gbMiniVariant) {
    window.__gbMiniVariant = true;
    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-gb-mini-variant]');
      if (!select) return;
      var card = select.closest('[data-gb-mini]'), opt = select.selectedOptions[0];
      if (!card || !opt) return;
      var add = $('[data-gb-add]', card), check = $('[data-gb-pair], [data-gb-fbt-check]', card), price = $('[data-gb-mini-price]', card);
      if (add) add.setAttribute('data-gb-add', select.value);
      if (check) { check.value = select.value; check.dataset.price = opt.dataset.price; check.dispatchEvent(new Event('change', { bubbles: true })); }
      if (price && opt.dataset.priceLabel) price.textContent = opt.dataset.priceLabel;
      card.dataset.variantId = select.value;
      card.dataset.price = opt.dataset.price;
    });
  }

  /* ---------- Product recommendations section ---------- */
  function initRecs(section) {
    if (section.hasAttribute('data-init')) return;
    section.setAttribute('data-init', '');
    var load = function () {
      var url = section.dataset.url;
      if (!url) return;
      fetchDoc(url).then(function (doc) {
        var fresh = doc.querySelector('[data-gb-recs-content]');
        var target = $('[data-gb-recs-content]', section);
        var count = fresh ? $$('[data-gb-recs-item]', fresh).length : 0;
        if (!count) {
          if (!design) section.closest('.shopify-section') ? section.closest('.shopify-section').setAttribute('hidden', '') : (section.hidden = true);
          return;
        }
        target.innerHTML = fresh.innerHTML;
        section.classList.add('is-loaded');
        target.querySelectorAll('[data-init]').forEach(function (n) { n.removeAttribute('data-init'); });
        initInjected(section);
      }).catch(function () {});
    };
    whenVisible(section, load);
  }

  /* ---------- Recently viewed ---------- */
  function initRecent(section) {
    if (section.hasAttribute('data-init')) return;
    section.setAttribute('data-init', '');
    var list = $('[data-gb-recent-list]', section);
    var limit = Number(section.dataset.limit) || 4;
    var exclude = section.dataset.exclude || '';
    var style = section.dataset.cardStyle || 'full';
    var handles = (window.GB && GB.recent ? GB.recent.all() : []).filter(function (h) { return h && h !== exclude; }).slice(0, limit);
    var wrapper = section.closest('.shopify-section');
    if (!handles.length) {
      if (!design && section.dataset.hideEmpty !== 'false') { if (wrapper) wrapper.hidden = true; else section.hidden = true; }
      else section.classList.add('is-empty');
      return;
    }
    whenVisible(section, function () {
      Promise.all(handles.map(function (h) {
        return fetchDoc(rootUrl() + '/products/' + encodeURIComponent(h) + '?section_id=gb-card-ajax')
          .then(function (doc) { var c = doc.querySelector('[data-gb-card-ajax]'); return c ? c.innerHTML.trim() : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        cards = cards.filter(Boolean);
        if (!cards.length) { if (!design && wrapper) wrapper.hidden = true; return; }
        list.innerHTML = cards.map(function (html) {
          return '<div class="gb-recent__item gb-recent__item--' + style + '">' + html + '</div>';
        }).join('');
        section.classList.add('is-loaded');
        initInjected(section);
      });
    }, '600px 0px');
  }

  /* ---------- Complementary products block (main product) ---------- */
  function initComplementary(block) {
    if (block.hasAttribute('data-init')) return;
    block.setAttribute('data-init', '');
    whenVisible(block, function () {
      fetchDoc(block.dataset.url).then(function (doc) {
        var tpl = doc.querySelector('template[data-gb-reco-mini]');
        var list = $('[data-gb-complementary-list]', block);
        var html = tpl ? tpl.innerHTML.trim() : '';
        if (!html) { if (!design) block.hidden = true; return; }
        list.innerHTML = html;
        block.hidden = false;
        initInjected(block);
      }).catch(function () {});
    }, '200px 0px');
  }

  /* ---------- Frequently bought together ---------- */
  function Fbt(section) {
    this.section = section;
    this.itemsWrap = $('[data-gb-fbt-items]', section);
    this.button = $('[data-gb-fbt-add]', section);
    section.setAttribute('data-init', '');
    var self = this;
    section.addEventListener('change', function (e) {
      if (e.target.matches('[data-gb-fbt-check]')) self.update();
    });
    if (this.button) this.button.addEventListener('click', function () { self.add(); });
    this.update();
    whenVisible(section, function () { self.load(); });
  }

  Fbt.prototype.load = function () {
    var self = this, s = this.section;
    if (!s.dataset.complementaryUrl) return;
    fetchDoc(s.dataset.complementaryUrl).then(function (doc) {
      var items = $$('[data-gb-fbt-item]:not([data-current])', doc);
      if (items.length) return self.replace(items);
      if (s.dataset.hasFallback === 'true' || !s.dataset.relatedUrl) return self.finish();
      return fetchDoc(s.dataset.relatedUrl).then(function (doc2) {
        var rel = $$('[data-gb-fbt-item]:not([data-current])', doc2);
        if (rel.length) self.replace(rel); else self.finish();
      });
    }).catch(function () { self.finish(); });
  };

  Fbt.prototype.replace = function (nodes) {
    var wrap = this.itemsWrap, limit = Number(this.section.dataset.limit) || 3;
    $$('[data-gb-fbt-item]:not([data-current]), .gb-fbt__item--skeleton', wrap).forEach(function (n) { n.remove(); });
    nodes.slice(0, limit).forEach(function (n) { wrap.appendChild(document.importNode(n, true)); });
    initInjected(this.section);
    this.finish();
  };

  Fbt.prototype.finish = function () {
    $$('.gb-fbt__item--skeleton', this.itemsWrap).forEach(function (n) { n.remove(); });
    var others = $$('[data-gb-fbt-item]:not([data-current])', this.itemsWrap).length;
    var wrapper = this.section.closest('.shopify-section');
    if (!others && !design) { if (wrapper) wrapper.hidden = true; else this.section.hidden = true; return; }
    this.section.classList.add('is-loaded');
    this.update();
  };

  Fbt.prototype.checked = function () {
    return $$('[data-gb-fbt-check]', this.section).filter(function (c) { return c.checked && !c.disabled; });
  };

  Fbt.prototype.update = function () {
    var s = this.section, checked = this.checked();
    var total = 0, compare = 0;
    checked.forEach(function (c) { total += Number(c.dataset.price) || 0; compare += Number(c.dataset.compare) || Number(c.dataset.price) || 0; });
    $$('[data-gb-fbt-item]', s).forEach(function (item) {
      var c = $('[data-gb-fbt-check]', item);
      item.classList.toggle('is-unchecked', !!c && !c.checked);
    });
    var pct = Number(s.dataset.discount) || 0, minItems = Number(s.dataset.minItems) || 2;
    var discounted = pct > 0 && checked.length >= minItems ? Math.round(total * (100 - pct) / 100) : total;
    var totalEl = $('[data-gb-fbt-total]', s), compareEl = $('[data-gb-fbt-compare]', s), countEl = $('[data-gb-fbt-count]', s), msg = $('[data-gb-fbt-discount]', s);
    if (totalEl) totalEl.textContent = money(discounted);
    if (compareEl) {
      var showCompare = discounted < compare;
      compareEl.hidden = !showCompare;
      compareEl.textContent = showCompare ? money(compare) : '';
    }
    if (countEl) countEl.textContent = checked.length;
    if (msg) msg.classList.toggle('is-active', pct > 0 && checked.length >= minItems);
    if (this.button) {
      this.button.disabled = !checked.length;
      var label = $('[data-gb-fbt-label]', this.button);
      if (label) {
        var all = checked.length === $$('[data-gb-fbt-check]:not([disabled])', s).length;
        label.textContent = (all ? this.button.dataset.labelAll : this.button.dataset.labelSome || this.button.dataset.labelAll).replace('[count]', checked.length);
      }
    }
  };

  Fbt.prototype.add = function () {
    var items = this.checked().map(function (c) { return { id: Number(c.value), quantity: 1 }; });
    if (!items.length || !window.GB || !GB.cart) return;
    var btn = this.button;
    GB.cart.add(items, btn).then(function () {
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 2400);
    }).catch(function () {});
  };

  /* ------------------------------------------------------------------ */
  var GBRecs = (window.GBRecs = {
    init: function (scope) {
      scope = scope || document;
      $$('[data-gb-recs]:not([data-init])', scope).forEach(initRecs);
      $$('[data-gb-recent]:not([data-init])', scope).forEach(initRecent);
      $$('[data-gb-complementary]:not([data-init])', scope).forEach(initComplementary);
      $$('[data-gb-fbt]:not([data-init])', scope).forEach(function (s) { new Fbt(s); });
    }
  });
  var boot = function () { GBRecs.init(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { GBRecs.init(e.target); });
})();
